import heroBg from '../assets/hero_bg.png';
import logoGlow from '../assets/glow_logo.svg';
import lockup from '../assets/hero_lockup.png';
import boltSm from '../assets/bolt_sm.svg';
import bolt from '../assets/bolt.svg';
import { Bolt, Coin } from './Decor';

const fmtDate = (ts) => {
  if (!ts) return '';
  try {
    return new Date(ts).toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' });
  } catch (e) {
    return '';
  }
};

/* Full-screen BBD-themed placeholder shown when the campaign is outside its
   live window — before it starts, or after it ends. Reuses the hero ribbon,
   glow and floating decorations so it stays on-brand. */
export default function CampaignState({ phase, date }) {
  const notStarted = phase === 'notStarted';
  const title = notStarted ? 'Campaign not started yet' : 'Campaign ended';
  const sub = notStarted
    ? (date ? `Come back on ${fmtDate(date)}` : 'Check back soon for the big deals.')
    : (date ? `This campaign ended on ${fmtDate(date)}` : 'Thanks for going big with us.');

  return (
    <div className="bbd-page">
      <div className="bbd-phone">
        <div className="bbd-hero bbd-state">
          <img className="bbd-hero-bg" src={heroBg} alt="" />

          <div className="bbd-hero-head">
            <img className="bbd-logo-glow" src={logoGlow} alt="" />
            <div className="bbd-lockup">
              <img src={lockup} alt="GoSats — The Big Billion Days with Flipkart" />
            </div>

            <Bolt className="bbd-bolt-hl bbd-state-float" src={boltSm} />
            <Coin className="bbd-coin-hl bbd-state-float-b" />
            <Bolt className="bbd-bolt-hr bbd-state-float-b" src={bolt} />
            <Coin className="bbd-coin-hr bbd-state-float" />

            <div className="bbd-state-card">
              <h1 className="bbd-state-title">{title}</h1>
              <p className="bbd-copy bbd-state-sub">{sub}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
